<template>
  <div class="callme_total_wrap hidden-md-and-down">
    <div class="callme_top_wrap" :style="{ backgroundImage: `url(${globalDicts['bottom_nav']})` }"></div>
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="items_wrap">
          <div class="item_tit">{{ menuList[1]?.menuName }}</div>
          <div class="item_options">
            <span @click="handleToRouter(item.routePath)" v-for="item in menuList[1]?.children">{{ item.menuName
            }}</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">{{ menuList[3]?.menuName }}</div>
          <div class="item_options">
            <span @click="handleToRouter(item.routePath)" v-for="item in menuList[3]?.children">{{ item.menuName
            }}</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">联系我们</div>
          <div class="item_options">
            <div class="massage_show">
              <p>{{ globalDicts['contact'] }}</p>
              <p>{{ globalDicts['email'] }}</p>
              <p>{{ globalDicts['address'] }}</p>
            </div>
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down" style="margin-left: 120px">
          <div class="item_tit">关注我们</div>
          <div class="item_options">
            <img :src="globalDicts['follow']" alt="" />
            <!-- <span style="text-align: center; margin-top: 15px">中助盈产业大脑...</span> -->
          </div>
        </div>
      </div>
      <div class="navigate_wrap">
        <span>友情链接:</span>
        <a :href="link.url" v-for="link in linkList">{{ link.linkName }}</a>
        <p>
          {{ globalDicts['icp'] }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { treeselect } from '../../api/menu';
import { getAllLinks } from '../../api/system';

export default {
  data() {
    return {
      activeIndex: '1',
      menuList: [{}, {}, {}, {}],
      linkList: []
    }
  },
  computed: {
    globalDicts() {
      return this.$store.getters.getDicts;
    },
  },
  methods: {
    handleToRouter(url) {
      this.$router.replace(url)
    },
    async treeselectFunc() {
      const res = await treeselect()
      if (res.data) {
        this.menuList = res.data.data

      }
    },
    async getAllLinksFunc() {
      const res = await getAllLinks()
      if (res.data) {
        this.linkList = res.data.data
      }
    }
  },
  mounted() {
    this.treeselectFunc()
    this.getAllLinksFunc()
  }
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  margin-top: 80px;

  .callme_top_wrap {
    width: 100%;
    height: 300px;
    background-size: 100% 100%;
  }

  .callme_bottom_wrap {
    width: 100%;
    background: #21282d;
    color: #fff;
    padding-top: 70px;

    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 60px;
      border-bottom: solid #363636 2px;

      .items_wrap {
        margin-right: 100px;

        .item_tit {
          font-size: 22px;
        }

        .item_options {
          display: flex;
          flex-direction: column;
          width: 120px;

          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16px;
            margin-top: 35px;
            cursor: pointer;

            &:hover {
              font-weight: bold;
            }
          }

          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300PX;

            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }

          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15px;
            width: 300PX;
            height: 80px;

            p {
              margin-top: 30px;
            }
          }

          img {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
    }

    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 40px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;

      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }

      span {
        color: #fff;
        padding-right: 30px;
        font-size: 18px;
        margin-right: 0;
      }

      p {
        font-size: 16px;
        color: #4e5557;
      }
    }
  }
}
</style>